import PropTypes from 'prop-types';
import { Tween } from 'react-gsap';
import classnames from 'classnames';
import ImageBackground from '../../image-background';
import Section from '../Section.jsx';
import styles from './SectionImage.module.scss';

function SectionImage({ zIndex, debug, showTitlesOnSide, isLast, scrub, start, end, src, className, credit, creditClassName, children }) {
  return (
    <Section zIndex={zIndex} debug={debug} isLast={isLast} showTitlesOnSide={showTitlesOnSide} scrub={scrub} start={start} end={end} className={styles.section}>
      <Tween from={{ opacity: 0 }} to={{ opacity: 1 }}>
        <div className={className}>
          <ImageBackground
            src={src}
            className={className}
          >
            {children}

            {
              credit && (
                <div className={classnames(styles.credit, creditClassName)}>
                  {credit}
                </div>
              )
            }
          </ImageBackground>
        </div>
      </Tween>
    </Section>
  );
}

SectionImage.propTypes = {
  zIndex: PropTypes.number,
  debug: PropTypes.bool,
  showTitlesOnSide: PropTypes.bool,
  isLast: PropTypes.bool,
  scrub: PropTypes.bool,
  start: PropTypes.string,
  end: PropTypes.string,
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
  credit: PropTypes.node,
  creditClassName: PropTypes.string,
  children: PropTypes.node,
};

export default SectionImage;
